module.exports = __webpack_public_path__ + "static/media/GZ5@2x.c414789b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/GZ/GZ5@2x.png
// module id = 651
// module chunks = 0